import { render, staticRenderFns } from "./ReportFac.vue?vue&type=template&id=4a85c275"
import script from "./ReportFac.vue?vue&type=script&lang=js"
export * from "./ReportFac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports